import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import type { FilterItem, keyPair } from "@repo/models";
import { KeyedArray } from "@repo/models";
import { mapToKeyedArray } from "@repo/models/filterItem";

export const BRANCHES = "branches";
export const CHANNELS = "channels";
export const BRANDS = "brands";
export const MARKETERS = "marketers";
export const STATES = "states";

export function useFilterItemQuery<T extends FilterItem = FilterItem>(
	name: string[],
	api: (...params) => Promise<(T | FilterItem)[]>,
	...params
) {
	const query = useQuery({ queryKey: [...name, ...params], queryFn: callApi });
	const [data, setData] = useState(query.data ?? emptyArray);
	const [loaded, setLoaded] = useState(query.isFetched);

	useEffect(() => {
		if (query.isFetched) setData(query.data);
		if (query.isFetched) setLoaded(true);
	}, [query.isFetched, query.data]);
	return [data, loaded] as [KeyedArray<T>, boolean];

	async function callApi() {
		return await api(...params).then(mapToKeyedArray);
	}
}

export function getItems(allItems: KeyedArray<FilterItem>, loaded: boolean, forceInclude?: FilterItem) {
	if (!allItems) return [] as keyPair[];
	if (forceInclude) allItems.set(forceInclude);
	return allItems.map((c) => {
		return { id: c.id, value: c.name } as keyPair;
	});
}

const emptyArray = new KeyedArray<FilterItem>([], (k) => k.id);
